import { z } from 'zod';
import { PublicUserSchema } from './user.schema';
import { MembershipSchema } from './membership.schema';
import { MEMBERSHIP_TYPE } from '../enums';

export const UserReferralSchema = z.object({
   user: PublicUserSchema,
   level: z.number().int().min(0).max(2),
   membershipTypeBonus: z.nativeEnum(MEMBERSHIP_TYPE),
});

export const ReferralMembershipRewardSchema = z.object({
   membership: MembershipSchema,
   goal: z.number(),
   current: z.number(),
   redeemed: z.boolean(),
   allowRedeem: z.boolean(),
});

export const UserReferralsSchema = z.object({
   userReferrals: z.array(UserReferralSchema).nullable(),
   pagination: z.object({
      page: z.number(),
      limit: z.number(),
      total: z.number().nullable(),
   }),
   counts: z.object({
      signups: z.number().min(0).nullable(),
      profilesCompleted: z.number().min(0).nullable(),
      membershipsPurchased: z.number().min(0).nullable(),
   }),
   membershipRewards: z.array(ReferralMembershipRewardSchema).nullable(),
});

export const UserReferralsResponseSchema = z.object({
   userReferrals: z.array(UserReferralSchema),
   counts: z.object({
      signups: z.number().min(0),
      profilesCompleted: z.number().min(0),
      membershipsPurchased: z.number().min(0),
   }),
   membershipRewards: z.array(ReferralMembershipRewardSchema),
});

export const AddReferredBySchema = z.object({
   code: z.string().min(5),
});
